module.exports = __webpack_public_path__ + "static/img/h-i-4.4db45004.png";